import { Suspense, useContext } from 'react'

import { type Resource, appTrace, useSuspensefulGetter } from '~/utils'

import { NoSsr } from '../context'
import { AuthActorContext } from './AuthProvider'

function WaitForAuthInner({
  children,
  resource,
}: {
  children: React.ReactNode
  resource: Resource<any>
}) {
  appTrace(`WaitForOnboarded: ${JSON.stringify(resource.read())}`)
  return <>{children}</>
}
export function WaitForOnboarded({ children }: { children: React.ReactNode }) {
  const { actor: authActor } = useContext(AuthActorContext)
  const resource = useSuspensefulGetter(
    authActor,
    (s) => s.matches('registration.complete'),
    (s) => s.value
  )
  return (
    <NoSsr>
      <Suspense>
        <WaitForAuthInner resource={resource}>{children}</WaitForAuthInner>
      </Suspense>
    </NoSsr>
  )
}
